import { GET_COURSES,ADD_COURSES, DELETE_COURSES } from '../actions/actionTypes';

const initialState = {
  coursecardItemData:[],coursetotalCount:0,coursecardData:[],cardItemDataShow:false,opentost:false,tost_msg:''
};

function checkdate (data)  {
  let enddate =false;
let date1 =   JSON.parse(data).issueDate;

  console.log('date1',date1);

  return date1;
}

export default function courses(state = initialState, action) {

  switch (action.type) {
      case GET_COURSES:
      
      return{
       ...state,
       coursecardData: action.getCardData,
       coursetotalCount:action.totalCount,
       coursecardItemData:action.cardItemData,
       cardItemDataShow:action.cardItemDataShow
      

      };
      case ADD_COURSES:
        //
        console.log("Action in add course: ", action)

        if(!action.newlyAddedCourse) {
          //course addition failed dont change state
          return {
            ...state
          }
        }

        let updatedCourses = state.coursecardItemData
        updatedCourses.push(action.newlyAddedCourse)

        let totalCount=0;
        let finaldata=[];
        let setCardItemDataShow=false;

        totalCount = updatedCourses.length

        let getCardItemData = updatedCourses.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

        if(totalCount > 3) {
          setCardItemDataShow = true
        }

        if(getCardItemData.length > 0) {
          for (let i = 0; i < getCardItemData.length; i++) {
            const id = getCardItemData[i].id
            const data = getCardItemData[i].newdata;
            let datecheck = checkdate(data);
            // not doing since it needs curdata
            // let status = findIdInCv(id, curdata.props)
            getCardItemData[i]['datecheck'] = datecheck;
  
            //restricted i.e. if education is publically viewable logic goes here. Add that logic if needed
  
            ///handling logic
          }
        }


        let getCardItemData2 = getCardItemData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))


        finaldata = getCardItemData2
  
        return {
          ...state,
          opentost:action.opentost,
          tost_msg:action.tost_msg,
          coursecardItemData: finaldata.length > 3 ? finaldata.slice(0,3) : finaldata,
          coursetotalCount: totalCount,
          cardItemDataShow: setCardItemDataShow,
          coursecardData: action.getCardData
        };
    
      case DELETE_COURSES: 
        console.log("Delete education reducer")
        if(action.deleteSuccess) {
          console.log("Course delete was successful")

          const coursesAfterDelete = action.coursecardItemData
          console.log("coursesAfterDelete", coursesAfterDelete)

          let totalCountAfterDelete
          let finaldataAfterDelete=[];
          let setCardItemDataShowAfterDelete=false;

          totalCountAfterDelete = coursesAfterDelete.length

          let cardItemsData = coursesAfterDelete.filter(item => item._deleted !== true).sort((a, b) => b.createdAt.localeCompare(a.createdAt));

          if(totalCountAfterDelete > 3) {
            setCardItemDataShowAfterDelete = true
          }

          if(cardItemsData.length > 0){
            for(let i=0;i< cardItemsData.length;i++) {
              const data = cardItemsData[i].newdata;
              let datecheck = checkdate(data);
              cardItemsData[i]['datecheck'] = datecheck;
            }
          }

          let cardItemsData2 = cardItemsData.sort((a, b) => Date.parse(b.datecheck) - Date.parse(a.datecheck))

          finaldataAfterDelete = cardItemsData2
          
          return {
            ...state,
            coursecardItemData: finaldataAfterDelete,
            coursetotalCount: totalCountAfterDelete,
            cardItemDataShow: setCardItemDataShowAfterDelete,
          }

        }  else {
          //delete was not successful, just return state with toast details
          //Note:- UI does not show error for failure, need to implement this
          console.log("Course Delete was not successfull")
          return {
            ...state
          }
        }


      default: return state;
  }
};

